module.exports = __webpack_public_path__ + "static/img/mast_CP02K_Ti.28150bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/mast_CP02K_Ti.jpg
// module id = 8tsh
// module chunks = 0